import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* deleteAvatarSaga() {
  yield call(SignalingSocket.send, {
    event: 'deleteAvatar',
  });
}
